import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useModalityLabel = () => {
  const { t: modalityTrans, i18n } = useTranslation('translation', {
    keyPrefix: 'common.modality',
  });

  return useCallback(
    (modality: string) =>
      i18n.exists(`common.modality.${modality}`)
        ? modalityTrans(modality)
        : modality,
    [i18n, modalityTrans],
  );
};

const normalizeReadable = (readable: string) => {
  return readable.replace(/[\-\(\)\s]/g, '').toLowerCase();
};
export const useConvertToModality = () => {
  const modalityLabel = useModalityLabel();
  const normalizedModalityMap = useMemo(
    () => ({
      BM: normalizeReadable(modalityLabel('BM')),
      BMD: normalizeReadable(modalityLabel('BMD')),
      CR: normalizeReadable(modalityLabel('CR')),
      CT: normalizeReadable(modalityLabel('CT')),
      DX: normalizeReadable(modalityLabel('DX')),
      ECG: normalizeReadable(modalityLabel('ECG')),
      ES: normalizeReadable(modalityLabel('ES')),
      MR: normalizeReadable(modalityLabel('MR')),
      MG: normalizeReadable(modalityLabel('MG')),
      NM: normalizeReadable(modalityLabel('NM')),
      PET: normalizeReadable(modalityLabel('PET')),
      RF: normalizeReadable(modalityLabel('RF')),
      US: normalizeReadable(modalityLabel('US')),
      XA: normalizeReadable(modalityLabel('XA')),
      XC: normalizeReadable(modalityLabel('XC')),
      PX: normalizeReadable(modalityLabel('PX')),
      OCT: normalizeReadable(modalityLabel('OCT')),
      IVOCT: normalizeReadable(modalityLabel('IVOCT')),
      IVUS: normalizeReadable(modalityLabel('IVUS')),
    }),
    [modalityLabel],
  );

  return useCallback(
    (readable: string) => {
      const normalizedReadable = normalizeReadable(readable);
      const modalityCodes = Object.entries(normalizedModalityMap)
        .filter(([, normalizedLabel]) =>
          normalizedLabel.includes(normalizedReadable),
        )
        .map(([modalityCode]) => modalityCode);

      return readable.length && !modalityCodes.length
        ? [readable]
        : modalityCodes;
    },
    [normalizedModalityMap],
  );
};
